import type { FaireProductEntity } from "../../entity_types/product";

export const p_xf4mt5hdha: FaireProductEntity = {
  token: "p_xf4mt5hdha",
  type: "product",
  name: "The World of Apartamento: ten years of everyday life",
  brandToken: "b_ap9qto2o",
  brandName: "Abrams",
  imageUrl:
    "https://cdn.faire.com/fastly/68330490f9de4ea1c90f4cd7acf5d9207faaebf15976b360c4dae38d86674d70.jpeg",
  galleryImageUrls: [],
  priceDollars: 33.15,
  description:
    "The World of Apartamento is a celebration of Apartamento magazine's 10th anniversary and features the best and most inspirational interiors from the publication's pages. Like the magazine itself, the book is a carefully developed editorial mix—high-quality writing and beautiful photography—that communicates genuine stories and intimate moments.\n\n\"Apartamento is how The Paris Review might have turned out had Sottsass been its guiding light instead of Hemingway. . . . A humble yet luminous print object that perfectly embodies the editors' grass-roots aesthetic.\" —New York Times\n\nApartamento is widely recognized as today's most influential interiors magazine. International, well designed, and simply written since 2008, it is an indispensable resource for individuals who are passionate about the way they live.",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:15.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
